import {useCallback, useMemo, FC} from 'react'
import {useDeleteGroupMutation} from 'src/app/appApiQueries'
import {setType} from 'src/app/modal'
import {useAppDispatch, useAppSelector} from 'src/hooks'
import ModalTitle from '../ModalTitle'
import useModalLoading from 'src/hooks/useModalLoading'
import {selectGroupName} from 'src/app/hostSettings'
import ModalButtons from '../ModalButtons'

type GroupDeleteModalProps = {
    groupId: string
}

export const GroupDeleteModal: FC<GroupDeleteModalProps> = ({groupId}) => {
    // we must memoize re-selectors if they will appear in different component instances
    const selectGroupNameMemo = useMemo(() => selectGroupName, [])
    const groupName = useAppSelector((state) =>
        selectGroupNameMemo(state, groupId)
    )
    const dispatch = useAppDispatch()
    const [deleteGroupTrigger, {isLoading, isSuccess, isError}] =
        useDeleteGroupMutation()

    useModalLoading({
        isLoading,
        isSuccess,
        isError,
    })

    const onDelete = useCallback(() => {
            deleteGroupTrigger({groupId: groupId})
                .unwrap()
                .then(() => {
                    dispatch(setType({type: null}))
                })
        },
        [dispatch, groupId, deleteGroupTrigger]
    )
    const onCancel = () => {
        dispatch(setType({type: null}))
    }

    return (
        <div>
            <ModalTitle text={`Delete "${groupName}"`}/>
            <ModalButtons
                firstButton={{
                    name: 'Cancel',
                    type: 'secondary',
                    onClick: onCancel,
                    htmlButtonType: 'button',
                }}
                secondButton={{
                    name: 'Delete',
                    type: 'warning',
                    onClick: onDelete,
                    htmlButtonType: 'button',
                }}
            />
        </div>
    )
}
